import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { join } from 'lodash';
import Yup from 'yup';
import { GridItem, TextFieldWrapper } from '../../common';

const SPECIALIST_TYPE = 'type';

function SpecialistTypeField({ required, paths }) {
  return (
    <GridItem xs={12}>
      <Field
        component={TextFieldWrapper}
        id={SPECIALIST_TYPE}
        label="Type of Doctor or Specialty"
        name={join([...paths, SPECIALIST_TYPE], '.')}
        paths={[...paths, SPECIALIST_TYPE]}
        required={required}
      />
    </GridItem>
  );
}

SpecialistTypeField.propTypes = {
  paths: PropTypes.array,
  required: PropTypes.bool,
};

const defaultRequired = false;

SpecialistTypeField.defaultProps = {
  paths: [],
  required: defaultRequired,
};

export default SpecialistTypeField;

export function getSpecialistTypeValidation(config = {}) {
  const { required = defaultRequired } = config;
  const specialistSchema = Yup.string();

  return {
    [SPECIALIST_TYPE]: required
      ? specialistSchema.required('Specialist type is required.')
      : specialistSchema,
  };
}



// WEBPACK FOOTER //
// ./src/modules/SpecialistPage/components/SpecialistTypeField.js